import React, { useState } from "react";
import { Container, Row, Col, Nav } from "react-bootstrap";
import SliderUpload from "./SliderUpload";
import Sidebar from "../Sidebar";
import TooltipMessage from "../Tooltip";
import { Breadcrumbs } from "./../Breadcrumb/index";

export default function LandingUpload() {
  const [index, setIndex] = useState(0);

  return (
    <>
      <Container fluid>
        <Row>
          <Sidebar />
          <Col lg={10} style={{ backgroundColor: "#f1f2f3" }}>
            <Row className="p-2">
              <Col className="slidesContent rounded shadow p-3 bg-light">
                <Breadcrumbs currentPathName="Slides Upload" />
                <div className="tabList">
                  <Nav variant="tabs" defaultActiveKey={0}>
                    <Nav.Item onClick={() => setIndex(0)}>
                      <Nav.Link eventKey={0}>
                        FIRST SLIDE
                        <small>
                          <TooltipMessage msg="*Resolution (1275px * 280px)" />
                        </small>
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item onClick={() => setIndex(1)}>
                      <Nav.Link eventKey={1}>
                        SECOND SLIDE
                        <small>
                          <TooltipMessage msg="*Resolution (1275px * 280px)" />
                        </small>
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item onClick={() => setIndex(2)}>
                      <Nav.Link eventKey={2}>
                        THIRD SLIDE
                        <small>
                          <TooltipMessage msg="*Resolution (1275px * 280px)" />
                        </small>
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>
                </div>
                <div className="tabContent" hidden={index !== 0}>
                  <SliderUpload buttonText="upload slide One" imgId={1} />
                </div>
                <div className="tabContent" hidden={index !== 1}>
                  <SliderUpload buttonText="upload slide Two" imgId={2} />
                </div>
                <div className="tabContent" hidden={index !== 2}>
                  <SliderUpload buttonText="upload slide Three" imgId={3} />
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </>
  );
}
